import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { DequeuePlayerOutput, WebAppRoutes } from "types/web-app";

export const dequeuePlayer = async (
  token: string
): Promise<ServiceResponse<DequeuePlayerOutput>> => {
  const response = await fetchWithAuth(
    `/${WebAppRoutes.DEQUEUE_PLAYER}`,
    token,
    {
      method: "POST",
    }
  );

  return response.json();
};

